<template>
    <div v-if="webOverlay">
        <div class="web-overlay top-10" v-if="webOverlay.isTop10">TOP10</div>
        <div class="web-overlay popular" v-if="webOverlay.isPopular">Popular</div>
        <div class="web-overlay new-model" v-if="webOverlay.tireHighlightText">{{ webOverlay.tireHighlightText }}</div>
        <div class="web-overlay tag-price" v-if="webOverlay.tireTagPriceText">{{ webOverlay.tireTagPriceText }}</div>
        <div class="web-overlay tire-year" v-if="webOverlay.tireYear">ปี {{ webOverlay.tireYear }}</div>
    </div>
</template>

<script>
export default {
    props: {
        webOverlay: {
            type: [ Array, Object ],
            required: false
        }
    },
}
</script>